import { Component, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-ticket-form',
  templateUrl: './ticket-form.component.html',
  styleUrls: ['./ticket-form.component.scss'],
  imports: [FormsModule, MatFormField, MatInput, MatButton],
})
export class TicketFormComponent {
  private http = inject(HttpClient);

  title: string;
  protocolLink: string;

  onSubmit() {
    const formData = {
      title: this.title,
      protocolLink: this.protocolLink,
    };

    this.http
      .post('/v1/ticketsystem/youtrack', formData)
      .subscribe((response) => {
        // Handle the response as needed
        console.log(response);
      });
  }
}
